import ChangesLayout from "../layouts/ChangesLayout";

const Changes = () => {
  return (
    <div className="p-8 bg-gray-100">
      <ChangesLayout />
    </div>
  );
};

export default Changes;
